import { Modal } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

interface ConfirmRemoveSubstituteModalProps {
    isShowing: boolean
    onCancel: () => void
    onSubmit: () => void
}

export const ConfirmRemoveSubstituteModal = ({ isShowing, onCancel, onSubmit }: ConfirmRemoveSubstituteModalProps) => {
    const { t } = useTranslation()

    return (
        <Modal
            title={t("confirm:employee.remove_substitute.title")}
            cancelText={t("confirm:employee.remove_substitute.cancel")}
            okText={t("confirm:employee.remove_substitute.confirm")}
            open={isShowing}
            maskClosable={true}
            onCancel={onCancel}
            onOk={onSubmit}
        >
            <div>{t("confirm:employee.remove_substitute.message")}</div>
        </Modal>
    )
}
